import { AxiosResponse } from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import {
    getPortalUserRequest,
    getPortalUsersRequest,
} from "../../services/portal-user/portal-user.service";
import {
    getPortalUsers,
    getPortalUsersFailure,
    getPortalUsersSuccess,
    getPortalUser,
    getPortalUserFailure,
    getPortalUserSuccess,
} from "../reducer/portal-users";
import {
    GetPortalUserActionPayload,
    GetPortalUsersActionPayload,
} from "../types/portal-users";

function* getPortalUsersSaga(action: GetPortalUsersActionPayload) {
    try {
        const { data }: AxiosResponse = yield call(
            getPortalUsersRequest,
            action.payload
        );
        yield put(getPortalUsersSuccess(data));
    } catch (error: any) {
        yield put(getPortalUsersFailure(error));
    }
}

function* getPortalUserSaga(action: GetPortalUserActionPayload) {
    try {
        const { data }: AxiosResponse = yield call(
            getPortalUserRequest,
            action.payload
        );
        yield put(getPortalUserSuccess(data));
    } catch (error: any) {
        yield put(getPortalUserFailure(error));
    }
}

export function* rootSaga() {
    yield takeLatest(getPortalUsers.type, getPortalUsersSaga);
    yield takeLatest(getPortalUser.type, getPortalUserSaga);
}
